// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"2f51240ff7a7a598bf87","777":"8c0d7e69a0125bb11f73"}[chunkId] + ".js";
};